import Modal from './components/Modal';
import ResponseModal from './components/ResponseModal';
import * as actions from './actions';
import reducer from './reducer';

export {
	actions,
	reducer,
	Modal,
	ResponseModal
};
export default Modal;
